module.exports = __webpack_public_path__ + "static/home-banner-img1-45eb9482ffb5dbbe2ff317b28fa76ba7.svg";